export default "__VITE_ASSET__CgmgNA1A__"